import React, { useEffect } from "react";
import { Container, Grid } from "@mui/material";
import { TabPanel } from "@mui/lab";
import { Form } from "react-final-form";
import { CloseIcon } from "../../../../styles/img/svg/CloseIcon";
import { BackIcon } from "../../../../styles/img/svg/BackIcon";
import OnboardImage from "../../../../styles/img/onboard-image.png";
import Validator from "../../../../_helpers/validate.schema";
import UiInput from "../../../_uiComponents/UiInput";
import {
  formatNicNumberInput,
  getFingerPrint,
  validPassportNumber,
} from "../../../../_helpers/support.services";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { UiButton } from "../../../_uiComponents/common/UiButton";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  alternativeFlowRegistrationType,
  nicValidateRequest,
  onboardingOtpConfirmRequest,
  removeFormDataFeilds,
} from "../../../../_redux/_actions/onboarding.actions";
import {
  commonConstants,
  onboardingConstants,
  regexPatterns,
  responseCodes,
} from "../../../../_redux/_constants";
import { UiNavTab } from "../../../_uiComponents/common/UiNavTab";
import { OtpConfirmModal } from "../../auth/views/OtpConfirmModal";
import { Fingerprint } from "@mui/icons-material";
import { AlreadyCustomer } from "../popups/AlreadyCustomer";
import { clearCommonErrors } from "../../../../_redux/_actions";

export const NicForm = (props) => {
  const {
    ownFormData: ownFormData,
    nicPassvalidateData,
    otpConfirmationData,
    onBoardingOtpTimer,
  } = useSelector((state) => state.onboarding);
  const errorMessage = useSelector((state) => state.errorMessage);

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [nicNumberError, setNicNumberError] = useState(false);
  const [passportNumberError, setPassportNumberError] = useState(false);
  const [alreadyCustomer, setAlreadyACustomer] = useState(false);
  const [formReady, setFormReady] = useState(false);
  const [showHideOtpConfirmation, setShowHideOtpConfirmation] = useState(null);
  const [payloadData, setPayloadData] = useState({});
  const [selectedTab, setSelectedTab] = useState(
    ownFormData?.selectedTab
      ? ownFormData.selectedTab
      : commonConstants.DOCUMENT_TYPE_NATIONAL_ID,
  );

  const validateSchema = () =>
    yup.object().shape({
      nicNumber: yup.string().when([], {
        is: () => selectedTab == commonConstants.DOCUMENT_TYPE_NATIONAL_ID,
        then: (schema) =>
          schema
            .test(
              "is-valid-nic",
              "NIC number must be in correct format",
              (value) => {
                if (!value) return false;
                return (
                  regexPatterns.OLD_NIC_NUMBER_REGEX.test(value) ||
                  regexPatterns.NEW_NIC_NUMBER_REGEX.test(value)
                );
              },
            )
            .required(t("This field is required")),
        otherwise: (schema) => schema.notRequired(),
      }),

      passportNumber: yup.string().when([], {
        is: () => selectedTab == commonConstants.DOCUMENT_TYPE_PASSPORT_ID,
        then: (schema) =>
          schema
            .matches(/^[0-9A-Za-z]{6,12}$/, "invalid passport")
            .max(12)
            .required(t("This field is required")),
        otherwise: (schema) => schema.notRequired(),
      }),
    });

  const onValidate = async (values) => {
    return await Validator(values, validateSchema);
  };

  const tabList = [
    {
      id: 1,
      label: t("NIC"),
      value: commonConstants.DOCUMENT_TYPE_NATIONAL_ID,
    },

    {
      id: 2,
      label: t("Passport"),
      value: commonConstants.DOCUMENT_TYPE_PASSPORT_ID,
    },
  ];

  const submit = async (identificationData) => {
    const fingetPrint = await getFingerPrint();

    let payload = {
      locale: i18n.language,
      personalId:
        selectedTab == commonConstants.DOCUMENT_TYPE_NATIONAL_ID
          ? identificationData.nicNumber
          : identificationData.passportNumber,
      personalIdTypeCode: selectedTab,
      checkByCBS: true,
      uid: fingetPrint,
    };

    let restoreData = {
      nicNumber: identificationData?.nicNumber,
      passportNumber: identificationData?.passportNumber,
      selectedTab: selectedTab,
    };

    payload.restoreData = restoreData;

    setPayloadData(payload);

    dispatch(nicValidateRequest(payload));
  };

  useEffect(() => {
    if (ownFormData?.nicNumber || ownFormData?.passportNumber) {
      props?.setIsFormDirty(true);
    }
  }, [ownFormData]);

  const showHideOTP = (param) => {
    setShowHideOtpConfirmation(param);
  };

  useEffect(() => {
    if (
      nicPassvalidateData?.isValidPersonalId &&
      (nicPassvalidateData?.isSubProfileActivationProcessCompleted ==
        commonConstants.YES_OPTION_TYPE ||
        nicPassvalidateData?.isSubProfileActivationProcessCompleted ==
          undefined)
    ) {
      if (onBoardingOtpTimer === 0 || onBoardingOtpTimer === undefined) {
        dispatch(removeFormDataFeilds(["registrationType"]));
        props?.changeFlowStep(
          onboardingConstants.SELECT_REGISTRATION_OPTION_STEP,
        );
      } else {
        showHideOTP(true);
      }
    }
  }, [nicPassvalidateData]);

  useEffect(() => {
    if (errorMessage?.customErrors.length > 0) {
      var status = errorMessage?.customErrors[0];

      if (status?.statusCode == responseCodes.OTP_REQUEST_LIMIT_REACHED) {
        showHideOTP(true);
      }
    }
  }, [onBoardingOtpTimer]);

  useEffect(() => {
    if (errorMessage?.customErrors.length > 0) {
      var status = errorMessage?.customErrors[0];

      if (status.statusCode == responseCodes.NO_PERSONAL_ID_FOR_ONBOARD) {
        props?.changeFlowStep(onboardingConstants.NOT_A_LOLC_CUSTOMER_PAGE);
      }

      if (status.statusCode == responseCodes.CUSTOMER_ALREADY_REGISTERED_OB) {
        dispatch(clearCommonErrors());
        setAlreadyACustomer(true);
      }
    }
  }, [errorMessage]);

  const onChangeTab = (tab) => {
    setSelectedTab(tab);
    setFormReady(false);
  };

  const confirmOtp = async (param) => {
    const fingetPrint = await getFingerPrint();

    let otpData = { ...param, uid: fingetPrint, locale: i18n.language };

    dispatch(onboardingOtpConfirmRequest(otpData));
  };

  const resendOtp = () => {
    let finalPayload = payloadData;

    dispatch(clearCommonErrors());

    dispatch(nicValidateRequest(finalPayload));
  };

  useEffect(() => {
    if (
      otpConfirmationData?.isSubProfileActivationProcessCompleted ==
      commonConstants.YES_OPTION_TYPE
    ) {
      showHideOTP(false);
      dispatch(
        alternativeFlowRegistrationType({
          registrationType:
            onboardingConstants.REGISTRATION_OPTION_CASA_ACCOUNT,
          alternativeFLowActive: commonConstants.YES_OPTION_TYPE,
        }),
      );
      dispatch(removeFormDataFeilds(["username"]));
      props?.changeFlowStep(onboardingConstants.ONBOARDING_USERNAME_STEP);
    }
  }, [otpConfirmationData]);

  useEffect(() => {
    setPayloadData({});
  }, []);

  return (
    <>
      <div className="df-user-profile df-onboard-progress-back-close df-profile-top-aligned-box df-onboard-nic-begin-tab">
        <Container maxWidth="md" className="df-pos-rel">
          <div
            className="df-user-profile__close-icon"
            onClick={() => {
              props?.closeBtn();
            }}
          >
            <CloseIcon />
          </div>

          <div className="df-user-profile__back-icon df-bc-w-progress">
            <BackIcon
              onClick={() => {
                props?.closeBtn();
              }}
            />
          </div>

          <div className="df-user-profile__body df-pw-tab">
            <UiNavTab
              value={selectedTab}
              onSelect={onChangeTab}
              tabNav={tabList}
            >
              <TabPanel value={commonConstants.DOCUMENT_TYPE_NATIONAL_ID}>
                <Grid container>
                  <Grid
                    size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                    className="text-center"
                  >
                    <h2 className="df-reset-pw-title df-onboard-toggle-position">
                      {t("Enter your identification number to begin")}
                    </h2>
                    <img
                      src={OnboardImage}
                      className="df-reset-pw-img df-onboard-side-img"
                    />
                  </Grid>

                  <Grid
                    size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                    className="text-right df-pl-2"
                  >
                    <div className="df-onboard-nic-wr">
                      <Form
                        initialValues={{
                          nicNumber: ownFormData?.nicNumber ?? "",
                          passportNumber: ownFormData?.passportNumber ?? "",
                        }}
                        onSubmit={submit}
                        validate={onValidate}
                        render={({
                          handleSubmit,
                          values,
                          submitting,
                          error,
                          hasValidationErrors,
                          form,
                        }) => {
                          const { dirty } = form.getState();

                          useEffect(() => {
                            if (
                              (selectedTab ===
                                commonConstants.DOCUMENT_TYPE_NATIONAL_ID &&
                                values.nicNumber !== "" &&
                                !hasValidationErrors) ||
                              (selectedTab ===
                                commonConstants.DOCUMENT_TYPE_PASSPORT_ID &&
                                values.passportNumber !== "" &&
                                !hasValidationErrors)
                            ) {
                              setFormReady(true);
                            } else {
                              setFormReady(false);
                            }
                          }, [values, hasValidationErrors]);

                          return (
                            <>
                              <div className="df-onboard-inputs">
                                {selectedTab ===
                                commonConstants.DOCUMENT_TYPE_NATIONAL_ID ? (
                                  <UiInput
                                    name="nicNumber"
                                    id="inputNicNumber"
                                    label={`${t("NIC Number")} *`}
                                    type="text"
                                    min={0}
                                    clearable={true}
                                    maxLength={12}
                                    value={values.nicNumber}
                                    inputonChange={(e) => {
                                      const rawInput = e.target.value.replace(
                                        /\s/g,
                                        "",
                                      );
                                      let cleaned = rawInput.replace(
                                        /[^0-9VXvx]/g,
                                        "",
                                      );
                                      if (cleaned.length > 12)
                                        cleaned = cleaned.slice(0, 12);
                                      cleaned = cleaned
                                        .split("")
                                        .filter((char, index) => {
                                          if (index < 9)
                                            return /[0-9]/.test(char);
                                          if (index === 9)
                                            return /[0-9VXvx]/.test(char);
                                          if (index > 9)
                                            return /[0-9]/.test(char);
                                          return false;
                                        })
                                        .join("");

                                      const result =
                                        formatNicNumberInput(cleaned);

                                      if (
                                        result.value === "" ||
                                        result.isValid
                                      ) {
                                        setNicNumberError(false);
                                      } else {
                                        setNicNumberError(result.message);
                                      }

                                      form.change("nicNumber", result.value);
                                    }}
                                    error={nicNumberError}
                                    helperText={
                                      nicNumberError ? nicNumberError : null
                                    }
                                  />
                                ) : (
                                  <UiInput
                                    name="passportNumber"
                                    id="inputPassportNumber"
                                    label={`${t("Passport Number")} *`}
                                    type="text"
                                    min={0}
                                    clearable={true}
                                    maxLength={12}
                                    value={values.passportNumber}
                                    inputonChange={(passportNumber) => {
                                      const value = passportNumber.target.value;
                                      if (value === "") {
                                        setPassportNumberError(false);
                                      } else if (!validPassportNumber(value)) {
                                        setPassportNumberError(
                                          t("Invalid passport number"),
                                        );
                                      } else {
                                        setPassportNumberError(false);
                                      }
                                      form.change(
                                        onboardingConstants.FIELD_NAME_ONBOARDING_PASSPORT_NUMBER,
                                        value,
                                      );
                                    }}
                                    error={passportNumberError}
                                    helperText={
                                      passportNumberError
                                        ? passportNumberError
                                        : null
                                    }
                                  />
                                )}
                              </div>
                              {selectedTab ===
                                commonConstants.DOCUMENT_TYPE_NATIONAL_ID && (
                                <div className="df-onboard-nic-wr__text">
                                  <span className="df-onboard-text">
                                    <Trans
                                      i18nKey="termsConsent"
                                      components={{
                                        br: <br />,
                                        1: (
                                          <a
                                            href={
                                              process.env
                                                .NFS_TERMS_CONDITION_LINK
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="df-primary-underlined-btn  mt-1 mb-1"
                                          >
                                            {" "}
                                            {t("termsButton")}{" "}
                                          </a>
                                        ),
                                      }}
                                    />
                                    <br />
                                  </span>
                                </div>
                              )}

                              <UiButton
                                onClick={handleSubmit}
                                className="df-ui-dark-bg-btn w-100 mt-2"
                                name={t("Next")}
                                disabled={!formReady}
                              />
                            </>
                          );
                        }}
                      />
                    </div>
                  </Grid>
                </Grid>
              </TabPanel>

              {/* Passport TabPanel */}
              <TabPanel
                value={commonConstants.DOCUMENT_TYPE_PASSPORT_ID}
                className="df-card-tab"
              >
                <Grid container>
                  <Grid
                    size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                    className="text-center"
                  >
                    <h2 className="df-reset-pw-title df-onboard-toggle-position">
                      {t("Enter your identification number to begin")}
                    </h2>
                    <img
                      src={OnboardImage}
                      alt="Forget Password"
                      className="df-reset-pw-img df-onboard-side-img"
                    />
                  </Grid>

                  <Grid
                    size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                    className="text-right df-pl-2"
                  >
                    <div className="df-onboard-nic-wr">
                      <Form
                        initialValues={{
                          passportNumber: ownFormData?.passportNumber ?? "",
                        }}
                        onSubmit={submit}
                        validate={onValidate}
                        render={({
                          handleSubmit,
                          values,
                          hasValidationErrors,
                          form,
                        }) => {
                          const { dirty } = form.getState();

                          useEffect(() => {
                            if (
                              values.passportNumber !== "" &&
                              !hasValidationErrors
                            ) {
                              setFormReady(true);
                            } else {
                              setFormReady(false);
                            }
                          }, [values, hasValidationErrors]);

                          return (
                            <>
                              <div className="df-onboard-inputs">
                                <UiInput
                                  name="passportNumber"
                                  id="inputPassport"
                                  label={`${t("Passport Number")} *`}
                                  type="text"
                                  maxLength={12}
                                  value={values.passportNumber}
                                  inputonChange={(e) => {
                                    const rawInput = e.target.value;
                                    const sanitized = rawInput
                                      .replace(/[^0-9A-Za-z]/g, "")
                                      .slice(0, 12);
                                    form.change(
                                      onboardingConstants.FIELD_NAME_ONBOARDING_PASSPORT_NUMBER,
                                      sanitized,
                                    );
                                    const result =
                                      validPassportNumber(sanitized);
                                    if (sanitized === "") {
                                      setPassportNumberError(false);
                                    } else {
                                      const result =
                                        validPassportNumber(sanitized);
                                      if (!result.isValid) {
                                        setPassportNumberError(result.message);
                                      } else {
                                        setPassportNumberError(false);
                                      }
                                    }
                                  }}
                                  error={passportNumberError}
                                  helperText={passportNumberError || null}
                                />
                              </div>

                              <div className="df-onboard-nic-wr__text">
                                <span className="df-onboard-text">
                                  <Trans
                                    i18nKey="termsConsent"
                                    components={{
                                      br: <br />,
                                      1: (
                                        <a
                                          href={
                                            process.env.NFS_TERMS_CONDITION_LINK
                                          }
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="df-primary-underlined-btn mt-1 mb-1"
                                        >
                                          {t("termsButton")}
                                        </a>
                                      ),
                                    }}
                                  />
                                </span>
                              </div>

                              <UiButton
                                onClick={handleSubmit}
                                className="df-ui-dark-bg-btn w-100 mt-2"
                                name={t("Next")}
                                disabled={!formReady}
                              />
                            </>
                          );
                        }}
                      />
                    </div>
                  </Grid>
                </Grid>
              </TabPanel>
            </UiNavTab>
          </div>
        </Container>
      </div>

      <OtpConfirmModal
        show={showHideOtpConfirmation}
        userDetails={{
          phone1:
            nicPassvalidateData?.phone1 ??
            nicPassvalidateData?.customer?.phone1,
          email:
            nicPassvalidateData?.email ?? nicPassvalidateData?.customer?.email,
        }}
        otpConfirmRequest={confirmOtp}
        otpResendRequest={resendOtp}
        closeModal={() => {
          showHideOTP(false);
        }}
        countDownTimer={onBoardingOtpTimer}
      />

      <AlreadyCustomer
        isOpen={alreadyCustomer}
        handleClose={setAlreadyACustomer}
      />
    </>
  );
};
